import { Modul_Text_Media } from "@/wp/types/acf-module-types";

export type TimeSettingsType = Modul_Text_Media["settings"];

export const checkModuleIsHidden = (
  TimeSettings: TimeSettingsType,
): boolean => {
  const { time_control, weekdays } = TimeSettings;

  if (time_control === "off") return false;

  if (time_control === "repeat-on-weekdays") {
    const today = new Date()
      .toLocaleString("en-US", { weekday: "long" })
      .toLowerCase() as
      | "sunday"
      | "monday"
      | "tuesday"
      | "wednesday"
      | "thursday"
      | "friday"
      | "saturday";

    return !weekdays.includes(today);
  }

  if (time_control === "single") {
    const start_date = convertDateFormat(TimeSettings.start_date);
    const end_date = convertDateFormat(TimeSettings.end_date);
    if (start_date && end_date) {
      const currentDate = new Date().getTime();
      return !(
        currentDate >= new Date(start_date).getTime() &&
        currentDate <= new Date(end_date).getTime()
      );
    }

    if (start_date) {
      const currentDate = getCurrentDate();
      return !(currentDate === start_date);
    }
  }

  return false;
};

const convertDateFormat = (dateStr: string) =>
  dateStr.replace(/(\d{2})\/(\d{2})\/(\d{4})/, "$2/$1/$3");

const getCurrentDate = (): string => {
  const date = new Date();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const year = date.getFullYear();

  return `${month}/${day}/${year}`;
};
